import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { Subscription } from 'rxjs';
import { ConcurrentAccessChannel } from './concurrent-access.channel';
import { ConcurrentAccessService, ConcurrentUser } from './concurrent-access.service';

@Component({
  selector: 'oir-concurrent-access',
  templateUrl: './concurrent-access.component.html',
  styleUrls: ['./concurrent-access.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConcurrentAccessComponent implements OnInit, OnDestroy {
  private visibilitySubscription: Subscription;
  private userCountSubscription: Subscription;
  private concurrentUserSubscription: Subscription;

  @Input() displayInfo = true;
  @Input() title: string;
  @Output() onConcurrentUserListChange: EventEmitter<ConcurrentUser[]> = new EventEmitter();
  @Output() onUserCountChange: EventEmitter<number> = new EventEmitter();

  public visible = false;
  public userCount = 0;
  public concurrentUserList: ConcurrentUser[] = [];

  constructor(
    private concurrentAccessService: ConcurrentAccessService,
    private channel: ConcurrentAccessChannel,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.channel.start();

    this.visibilitySubscription = this.concurrentAccessService.visibility.subscribe(
      (visible) => {
        this.visible = visible;
        this.cd.markForCheck();
      }
    );

    this.userCountSubscription = this.concurrentAccessService.userCount.subscribe(
      (count) => {
        this.userCount = count;
        this.onUserCountChange.emit(this.userCount);
      }
    );

    this.concurrentUserSubscription = this.concurrentAccessService.concurrentUsers.subscribe(
      (list) => {
        this.concurrentUserList = list;
        this.onConcurrentUserListChange.emit(this.concurrentUserList);
      }
    );
  }

  ngOnDestroy(): void {
    this.channel.stop();

    if (this.visibilitySubscription) {
      this.visibilitySubscription.unsubscribe();
      this.visibilitySubscription = null;
    }
    if (this.userCountSubscription) {
      this.userCountSubscription.unsubscribe();
      this.userCountSubscription = null;
    }
    if (this.concurrentUserSubscription) {
      this.concurrentUserSubscription.unsubscribe();
      this.concurrentUserSubscription = null;
    }
  }
}
